import { render, staticRenderFns } from "./HazardAssessmentDisplay.vue?vue&type=template&id=02401b63&"
import script from "./HazardAssessmentDisplay.vue?vue&type=script&lang=js&"
export * from "./HazardAssessmentDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports